var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWinners = function SvgWinners(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 36,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M13.808 9.351c-3.48 1.088-6.224 3.648-6.643 8.37-.359 3.98 1 11.297 6.71 13.017 8.915 2.685 24.428 1.516 26.126-5.34 1.15-4.648 1.504-12.97-4.956-15.561-4.385-1.755-13.778-2.816-21.237-.486",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD200",
    d: "m30.82 10.469 1.421 1.738a.785.785 0 0 0 1.28-.09l.651-1.002.535.393s-.522 1.433-1.443 2.208c-.92.775-3.242-1.698-3.242-1.698z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m30.82 10.469 1.421 1.738a.785.785 0 0 0 1.28-.09l.651-1.002.535.393s-.522 1.433-1.443 2.208c-.92.775-3.242-1.698-3.242-1.698z",
    opacity: 0.09
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4A28C",
    d: "M31.065 8.716a2.7 2.7 0 0 1-.164.716.22.22 0 0 1-.292.109.49.49 0 0 1-.31-.429l-.062-.4a.4.4 0 0 1 .246-.384c.275-.136.62.12.582.388"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4A28C",
    d: "m30.25 8.779-.475 1.357.767.207.037-1.07zM31.026 8.99l.09.188a.07.07 0 0 1-.028.091.1.1 0 0 1-.034.01h-.17z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#CE8172",
    d: "M30.58 9.507a.5.5 0 0 1-.224-.195.82.82 0 0 0 .201.568z",
    opacity: 0.31
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#A85796",
    d: "m30.099 9.209.264.024s.327-.239.307-.589c0 0 .265.225.501.045.237-.179.113-.558-.173-.679-.285-.12-1.126-.254-.9 1.199"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD200",
    d: "m29.775 10.137.767.206s1.433.717 1.458 2.15-1.871 3.422-1.871 3.422l-2.47-1.089s-.65-4.737 2.116-4.69"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4A28C",
    d: "M34.313 11.222s.12-.51.513-.49c.395.022-.17.742-.17.742z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD200",
    d: "m29.734 10.943-.202-5.799-.642-.105s-1.02 3.997-.798 6.067 1.642.642 1.642-.163"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m29.734 10.943-.202-5.799-.642-.105s-1.02 3.997-.798 6.067 1.642.642 1.642-.163",
    opacity: 0.46
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4A28C",
    d: "M29.431 5.136s.279-.423.039-.612c-.24-.188-.392-.238-.47-.013-.047.174-.06.355-.04.534zM17.329 8.646a2.5 2.5 0 0 0 .01.679.203.203 0 0 0 .247.156.45.45 0 0 0 .365-.33l.134-.358a.37.37 0 0 0-.15-.397c-.224-.167-.59 0-.606.25"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4A28C",
    d: "m18.061 8.863.167 1.329-.739.04.176-.984z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4A28C",
    d: "M17.752 9.01s.008-.157.125-.141c.117.015.108.238-.054.259zM17.315 8.903l-.12.154a.065.065 0 0 0 .037.104l.155.035z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4A28C",
    d: "M17.489 10.238s-1.13.167-1.465-1.266c-.336-1.432 1.178-2.507 1.178-2.507s.763-.202.402-.608c-.362-.406-.836.31-.836.31s-2.293 1.056-1.832 3.084c.46 2.027 1.722 2.675 1.722 2.675z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#CE8172",
    d: "M17.617 9.462a.5.5 0 0 0 .239-.135.77.77 0 0 1-.297.478z",
    opacity: 0.31
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD200",
    d: "M16.535 10.82s-1.51 1.586-.387 2.54c1.124.956 1.659 1.497 1.659 1.497l2.09-.66s-.093-1.7.238-2.674-.22-1.534-.783-1.558-1.407-.317-2.817.855"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M18.057 9.983s-.81 1.087-.113 1.947c.696.86.974 2.577.974 2.577l.978-.31s-.046-1.597.135-2.268q.136-.429.207-.873c.029-.292-1.162-1.281-1.162-1.281z",
    opacity: 0.09
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4A28C",
    d: "M19.563 11.764c-.75.513-1.569-.553-.901-1.17a5 5 0 0 1 .597-.478c.75-.494 1.563-2.58.597-3.668 0 0-.553-.658-.12-.873s.513.76.513.76 1.591 1.693.803 3.294c-.427.866-.918 1.746-1.489 2.135"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#655D8A",
    d: "M17.7 8.759s.009 1.45.944 1.42c.935-.028 1.152-.484 1.287-.858s-1.51.397-1.58-.635-.922-.806-1.14-.46c-.219.346.49.533.49.533"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4A28C",
    d: "M22.464 4.367c.045.038.19-.142.21-.182a.7.7 0 0 0 .1-.462c-.025-.098-.125-.247-.239-.25a.35.35 0 0 0-.285.226q-.072.135-.13.276c-.03.086.015.12.08.173q.13.11.264.219"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD200",
    d: "M22.31 9.154s-.2-2.77.342-4.753l-.532-.426s-1.542 3.567-.956 7.185z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4A28C",
    d: "M26.573 5.229c-.058.036-.15-.182-.16-.213-.046-.17-.158-.358-.048-.533a.35.35 0 0 1 .29-.146c.12.024.191.155.225.261q.054.144.09.292c.017.09-.032.12-.104.16z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD200",
    d: "M26.038 9.987s.597-2.711.342-4.75l.59-.347s1.013 3.75-.082 7.248z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.31 9.154s-.2-2.77.342-4.753l-.532-.426s-1.542 3.567-.956 7.185zM26.038 9.987s.597-2.711.342-4.75l.59-.347s1.013 3.75-.082 7.248z",
    opacity: 0.46
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD200",
    d: "M26.972 11.417c-.226 2.388-1.503 4.383-1.503 4.383l-3.073-.174s-3.344-6.575.955-6.67h.853q.29.015.575.07.144.027.307.068.232.06.455.147c.765.297 1.55.912 1.43 2.176"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#035B60",
    d: "m25.637 16.546-.169-.746-3.073-.174-.084.92z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M25.543 9.239c-.071.462-.25.938-.674 1.132-.932.424-1.05-.497-1.05-.497-.12-.186 0-.54.19-.881l.663.02s.038 0 .106.01q.144.028.307.069.234.06.458.147",
    opacity: 0.08
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4A28C",
    d: "M23.664 8.833q.053.195.081.394c.025.181.112.448.406.47.454.036.498-.68.498-.68s.211-.688-.28-.729c-.442-.036-.857-.051-.705.545"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4A28C",
    d: "M24.624 9.044s0-.216.191-.227c.191-.01.155.401-.191.227M23.792 9.015s.044-.21-.138-.262c-.181-.052-.237.353.138.262"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#035B60",
    d: "M23.664 8.833s-.732-.028-.465-.597c.268-.57.38-.175.489-.597.108-.423.239-.521.477-.37.24.152.064.543.39.404.328-.138.548-.259.64.015.094.273.045.413-.163.531-.207.118.173.46-.358.67s-.876-.358-.876-.358z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#00D9A5",
    d: "M32.5 13.878v6.945a6.415 6.415 0 0 1-6.425 6.424h-4.39a6.42 6.42 0 0 1-6.424-6.424v-6.945z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#00D9A5",
    d: "M25.5 25.54h-3.242v6.098H25.5z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#035B60",
    d: "M29.141 30.51H18.618v2.018H29.14z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#00D9A5",
    d: "M15.348 21.88H14.32a2.994 2.994 0 0 1 0-5.986h.94V14.7h-.94a4.188 4.188 0 0 0 0 8.374h1.346a6.4 6.4 0 0 1-.318-1.194M33.435 14.7h-.94v1.194h.94a2.994 2.994 0 0 1 0 5.986h-1.028a6.4 6.4 0 0 1-.317 1.194h1.345a4.187 4.187 0 0 0 0-8.375"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.783 21.887c.056.558.12 1.122.324 1.646a3.5 3.5 0 0 0 2.798 2.188c.32.038.738-.04.8-.358.044-.222-.12-.425-.269-.597-1.323-1.613-1.409-3.898-1.208-5.97.063-.655.148-1.314.076-1.967-.071-.654-.322-1.314-.823-1.74-.347-.295-.98-.565-1.384-.23a1.24 1.24 0 0 0-.346.562c-.183.538-.179 1.105-.146 1.672.027.436-.068.845-.055 1.285q.057 1.754.233 3.509",
    opacity: 0.3
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "m14.993 25.691-2.292-.568-.16.644 2.292.568zM20.058 28.06l-2.326.404.113.654 2.326-.404zM32.585 26.95l-2.118 1.041.292.596 2.12-1.04zM13.935 12.147l-1.236.607.17.347 1.236-.607zM12.88 9.12l-1.349-.278-.078.379 1.349.278zM36.61 13.364l-1.349-.278-.078.38 1.349.277zM33.879 8.24l-1.151.754.212.324 1.151-.755zM36.131 24.297l-2.36.078.023.664 2.36-.079z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m24.075 16.884.905 1.832a.22.22 0 0 0 .16.12l2.024.294a.216.216 0 0 1 .178.264.2.2 0 0 1-.059.102l-1.464 1.426a.22.22 0 0 0-.062.191l.346 2.013a.215.215 0 0 1-.311.227l-1.81-.955a.21.21 0 0 0-.2 0l-1.809.955a.215.215 0 0 1-.312-.227l.347-2.013a.22.22 0 0 0-.062-.191l-1.465-1.426a.215.215 0 0 1 .12-.366l2.023-.294a.22.22 0 0 0 .161-.12l.905-1.832a.214.214 0 0 1 .385 0",
    opacity: 0.43
  })));
};
export default SvgWinners;